import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/delete.png'


const _withScopeId = n => (_pushScopeId("data-v-41860276"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "camera-video-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { BrowserMultiFormatReader, Result, NotFoundException } from '@zxing/library';
  import { nextTick, ref } from 'vue';
  import { alert } from '@/utils';
  import _ from 'lodash';
  import { useI18n } from 'vue-i18n';

  interface IEmits {
    (event: 'change', data: string): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  emits: ["change"],
  setup(__props, { emit: emits }: { emit: ({
    (event: 'change', data: string): void;
  }), expose: any, slots: any, attrs: any }) {

  // https://github.com/zxing-js/library
  const { t } = useI18n();
  
  const video = ref<HTMLVideoElement | null>(null);
  const renderVideo = ref(false);
  const codeReader = new BrowserMultiFormatReader();

  const showManualPlay = ref(false);
  async function tryPlayVideo() {
    if (video.value) {
      try {
        await video.value.play();
        showManualPlay.value = false;
      } catch (e: any) {
        if (_.get(e, 'message', '').includes('NotAllowed')) {
          showManualPlay.value = true;
        }
      }
    }
  }

  async function getBarcodeDetector() {
    if ('BarcodeDetector' in window) {
      if (_.isFunction(window.BarcodeDetector.getSupportedFormats)) {
        const supportedFormats = await window.BarcodeDetector.getSupportedFormats();
        const formats = ['code_39', 'code_93', 'codabar', 'ean_13', 'ean_8', 'itf', 'qr_code', 'upc_a', 'upc_e'];
        // 有的手机支持这些api但是 不支持识别任何类型的码
        if (supportedFormats.length && formats.every(item => supportedFormats.includes(item))) {
          return new window.BarcodeDetector();
        }
      }
      return null;
    }
    return null;
  }

  function reset() {
    codeReader.reset();
    renderVideo.value = false;
    showManualPlay.value = false;
  }

  async function decodeByBarcodeDetector(barcodeDetector: any): Promise<string> {
    const capture = (cb: (e:any, val: string) => void) => {
      const loop = async () => {
        if (!video.value) {
          return;
        }
        try {
          const barcodes = await barcodeDetector.detect(video.value);
          if (barcodes.length) {
            cb(null, barcodes[0].rawValue);
            return ;
          }
          window.requestAnimationFrame(loop);
        } catch (e) {
          cb(e, '');
        }
      };
      loop();
    };

    return new Promise((resolve, reject) => {
      capture((e: any, val: string) => {
        if (e) {
          return reject(e);
        }
        resolve(val);
      });
    });
  }

  async function decodeByCodeReader(): Promise<string> {
    if (!video.value) {
      return '';
    }
    try {
      const result: Result = await codeReader.decodeFromVideoElement(video.value);
      return result.getText();
    } catch (e) {
      if (e instanceof NotFoundException) {
        return '';
      }
      throw e;
    }
  }

  async function decode(): Promise<string> {
    const barcodeDetector = await getBarcodeDetector();
    if (barcodeDetector) {
      return decodeByBarcodeDetector(barcodeDetector);
    }
    return decodeByCodeReader();
  }

  async function handleGetDevices() {
    showManualPlay.value = false;
    try {
      if (!_.get(navigator, 'mediaDevices.getUserMedia') && location.protocol !== 'https:') {
        throw new Error('Please use the "HTTPS" environment');
      }
      // 不加exact qq浏览器第二次调用api promise会一直pending 不报错  不成功
      const videoMediaStream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: { exact: 'environment' } } });
      renderVideo.value = true;
      await nextTick();
      if (video.value) {
        video.value.srcObject = videoMediaStream;
        setTimeout(() => {
          tryPlayVideo();
        }, 300);
      }
    } catch (e: any) {
      alert(e.message);
      throw e;
    }
  }

  async function handleVideoPlay() {
    try {
      const result = await decode();
      if (result) {
        emits('change', result);
      }
    } catch (e: any) {
      alert(e.message);
      throw e;
    } finally {
      reset();
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_AppIconScan = _resolveComponent("AppIconScan")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "trigger",
      onClick: handleGetDevices
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (renderVideo.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("video", {
            ref_key: "video",
            ref: video,
            mute: "",
            playsinline: "",
            onPlay: handleVideoPlay
          }, null, 544),
          _createElementVNode("div", {
            class: "btn-close",
            onClick: reset
          }, _hoisted_3),
          (showManualPlay.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "muanual-play-container",
                onClick: tryPlayVideo
              }, [
                _createVNode(_component_AppIconScan),
                _hoisted_4,
                _createElementVNode("p", null, _toDisplayString(_unref(t)('click_to_scan')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})